module.exports = __webpack_public_path__ + "media/images/visa_master-4114abe566cb430590c6dde208aa1f68.png";